var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"campaign-statistics"},[_c('h3',{staticClass:"campaign-statistics__title"},[_vm._v("\n    Campaign statistics\n  ")]),_c('AnalyticsCardList',{attrs:{"list":_vm.statistics,"columns":"3"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }